import {
	UFOExperience,
	ExperienceTypes,
	ExperiencePerformanceTypes,
	untilAll,
} from '@atlassian/ufo';

export const UniversalCreateExperience = new UFOExperience('universal-create', {
	type: ExperienceTypes.Operation,
	performanceType: ExperiencePerformanceTypes.Custom,
	until: untilAll([{ category: 'universal-create.create-issue' }]),
});
